// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__Zo5PH","button":"Tab_button__SKymP","button__active":"Tab_button__active__yy-mB"};